import { render } from "./manage-resumes.vue?vue&type=template&id=2e8674bf"
import script from "./manage-resumes.vue?vue&type=script&lang=js"
export * from "./manage-resumes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__